<template>
  <div :class="`modal fixed z-50 w-screen h-screen top-0 left-0 flex items-center justify-center ${(show ? 'pointer-events-auto': 'opacity-0 pointer-events-none')}`">
    <div ref="wrap" class="modal-container text-center w-full z-50 pt-16 pb-12 max-h-screen overflow-y-scroll scrolling-touch portrait-sp:-mt-40">
      <button class="modal-overlay fixed top-0 left-0 w-full h-full bg-black md:bg-gray-900 opacity-100 md:opacity-75" @click="onClose" />
      <div class="modal-content block lg:inline-block relative text-center md:px-6 mx-auto">
        <button class="modal-close fixed md:absolute top-0 right-0 mt-10 md:-mt-10 mr-6 z-10" @click="onClose" >
          <img class="h-8 w-8" src="~/assets/img/cross_white.svg" />
        </button>
        <div class="video-wrap w-full h-0 max-w-full mx-auto relative">
          <YoutubeVue
            v-if="videoid"
            ref="youtube"
            :videoid="videoid"
            class="absolute top-0 left-0 w-full h-full"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { YoutubeVue } from 'youtube-vue'
export default {
  components: { YoutubeVue },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    videoid: {
      type: String || null,
      default: null
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name) {
      document.removeEventListener('keydown', this.onKeydown)
    }
    next()
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown)
  },
  watch: {
    show(val) {
      val && this.$refs.wrap.scrollTo(0, 0)
    },
    videoid(val) {
      if (val) {
        this.$nextTick(this.onStopVideo)
      }
    }
  },
  methods: {
    onKeydown(e) {
      // 27 is the code for the escape key
      if (e.keyCode === 27) {
        this.onClose()
      }
    },
    async onClose() {
      await this.onStopVideo()
      this.$emit('close', true)
    },
    async onStopVideo() {
      const player = this.$refs.youtube && this.$refs.youtube.player
      const state = player && await player.getPlayerState() || 0;
      (state >= 1) && player && player.stopVideo()
    }
  }
}
</script>

<style lang="sass" scoped>
.video-wrap
  padding-top: 56.25%
  @screen md
    width: 900px
    height: 506px
    max-height: calc(100vh - 8rem)
    padding-top: 0
</style>